"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayBetSlipResultType = void 0;
var PayBetSlipResultType;
(function (PayBetSlipResultType) {
    PayBetSlipResultType[PayBetSlipResultType["Unknown"] = 0] = "Unknown";
    PayBetSlipResultType[PayBetSlipResultType["Ok"] = 1] = "Ok";
    PayBetSlipResultType[PayBetSlipResultType["BetSlipAlreadyPaid"] = 2] = "BetSlipAlreadyPaid";
    PayBetSlipResultType[PayBetSlipResultType["BetSlipNotToPay"] = 3] = "BetSlipNotToPay";
    PayBetSlipResultType[PayBetSlipResultType["AccountBookingFailed"] = 4] = "AccountBookingFailed";
    PayBetSlipResultType[PayBetSlipResultType["BetSlipPayExpired"] = 5] = "BetSlipPayExpired";
    PayBetSlipResultType[PayBetSlipResultType["InvalidBetSlipSpecified"] = 6] = "InvalidBetSlipSpecified";
    PayBetSlipResultType[PayBetSlipResultType["PINEmpty"] = 7] = "PINEmpty";
    PayBetSlipResultType[PayBetSlipResultType["PINMismatch"] = 8] = "PINMismatch";
    PayBetSlipResultType[PayBetSlipResultType["AccountHasInsufficientBalance"] = 9] = "AccountHasInsufficientBalance";
    PayBetSlipResultType[PayBetSlipResultType["InvalidBranch"] = 10] = "InvalidBranch";
    PayBetSlipResultType[PayBetSlipResultType["InternalError"] = 99] = "InternalError";
})(PayBetSlipResultType = exports.PayBetSlipResultType || (exports.PayBetSlipResultType = {}));
